export default __webpack_public_path__ + "static/media/DNo.38-4.c5839bf3.jpg";